import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { AppSettings, defaults } from 'src/app/config';
import { LocalStorageService } from './local-storage.service';

@Injectable({
   providedIn: 'root',
})
export class CoreService {
   private localStorageService = inject(LocalStorageService);

   get notify(): Observable<Record<string, any>> {
      return this.notify$.asObservable();
   }

   private notify$ = new BehaviorSubject<Record<string, any>>({});

   private options: AppSettings = this.loadInitialOptions();

   getOptions() {
      return this.options;
   }

   setOptions(options: AppSettings) {
      this.options = Object.assign(defaults, options);
      this.applyThemeToDocument(this.options.theme);
      this.notify$.next(this.options);
   }

   isDarkTheme(): boolean {
      return this.options.theme === 'dark';
   }

   toggleTheme(): void {
      const theme = this.isDarkTheme() ? 'light' : 'dark';
      this.options = { ...this.options, theme };
      this.localStorageService.setAppTheme(theme);
      this.applyThemeToDocument(theme);
      this.notify$.next(this.options);
   }

   applyThemeToDocument(theme: string): void {
      const html = document.documentElement;
      if (theme === 'dark') {
         html.classList.add('dark-theme');
         html.classList.remove('light-theme');
      } else {
         html.classList.remove('dark-theme');
         html.classList.add('light-theme');
      }
   }

   getLanguage() {
      return this.options.language;
   }

   setLanguage(lang: string) {
      this.options.language = lang;
      this.notify$.next({ lang });
   }

   private loadInitialOptions(): AppSettings {
      const storedTheme = this.localStorageService.getAppTheme();
      const options = { ...defaults };
      if (storedTheme === 'dark' || storedTheme === 'light') {
         options.theme = storedTheme;
      }
      this.applyThemeToDocument(options.theme);
      return options;
   }
}
